export default __webpack_public_path__ + "static/LeituraSansTwo-Medium-e58f4523b74e9377acc1f01c111a8f6e.woff";